import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../../../store/store.interface";
import store, { waitForCustomerLogin } from "../../../store/store";
import { ActionStatus } from "../../../common/constants/action-status";
import { getWishlistByWhislistIdUrlMagento } from "../utils/wish-list.util";
import { getFetchWishlistsApiCallMagento } from "../apis/wish-list-my-account.api";

export const fetchWishListByWishListId = createAsyncThunk('wishList/fetchByWishListId', async (wishListId: number, thunkAPI) => {
  const state = thunkAPI.getState() as StoreState;

  const userProfileResponse = store.getState().userProfileState.userProfileResponse;
  if (userProfileResponse?.status !== ActionStatus.succeeded || !userProfileResponse.data) {
    return;
  }
      
  await waitForCustomerLogin();

  const url = getWishlistByWhislistIdUrlMagento(state, wishListId);
  return await getFetchWishlistsApiCallMagento(url);
  }, {
  condition: ((_arg, { getState }) => {
    const state = getState() as StoreState;
    if (state.wishListState.getWishListById.status == ActionStatus.loading) {
      return false;
    }
    return true;
  })
});